function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41 31.5a13 8.5 0 11-26 0 13 8.5 0 1126 0z",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.5 21.5a1.5 1.5 0 11-3 0 1.5 1.5 0 113 0zM32.5 21.5a1.5 1.5 0 11-3 0 1.5 1.5 0 113 0z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M14.63 19.816c-3.337 4.049-8.115 5.622-10.672 3.515C1.4 21.223 2.033 16.232 5.37 12.184c3.337-4.049 10.672-3.515 10.672-3.515l-5.088 6.173 6.36-.129s-1.34 3.472-2.684 5.103z",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.6 24C.394 31.782 15.2 34 15.2 34M9 24c4.512 1.152 5.431 2.603 7 4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.072 19.816c3.337 4.049 8.116 5.622 10.673 3.515 2.557-2.108 1.924-7.099-1.413-11.147C46.995 8.135 39.66 8.669 39.66 8.669l5.088 6.173-6.36-.129s1.34 3.472 2.684 5.103z",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.102 24c4.206 7.782-10.6 10-10.6 10M46.702 24c-4.512 1.152-5.431 2.603-7 4M17.9 37s-6.99-1.557-9.9 0c-2.12 1.134-4 6-4 6s4.584-2.221 7-3c2.925-.943 9-2 9-2M24 39.6s-7.908.042-10 2.8c-1.41 1.86 0 7 0 7s2.367-3.626 4-5c2.329-1.96 8-4.4 8-4.4M38.1 37s6.99-1.557 9.9 0c2.12 1.134 4 6 4 6s-4.584-2.221-7-3c-2.925-.943-9-2-9-2M32 39.6s7.908.042 10 2.8c1.41 1.86 0 7 0 7s-2.367-3.626-4-5c-2.329-1.96-8-4.4-8-4.4"
}));

var SvgCrab = function SvgCrab(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrab, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Crab.a2ef9b07.svg";
export { ForwardRef as ReactComponent };